var map = {
	"./screen1.png": 378,
	"./screen2.png": 379,
	"./screen3.png": 380,
	"./screen4.png": 381,
	"./screen5.png": 382,
	"./screen6.png": 383,
	"./screen7.png": 384,
	"./screen8.png": 385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;